import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

export const useStyles = makeStyles<ITheme>((theme) => ({
  root: {
    paddingTop: 0,
    margin: 0,
  },
  tasksContainer: {
    margin: '32px 0 0 0',
  },
  journeyTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  eventsSection: {
    [theme.breakpoints.down(780)]: {
      display: 'block',
    },
  },
  emptyTasksContainer: {
    color: colors.darkGray,
    paddingBottom: theme.spacing(3),
  },
  contentContainer: {
    padding: '0 24px',
  },
  contentTopDescription: {
    padding: '16px 0 24px 0',
    maxWidth: '725px',
  },
  bookingsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  bookingCard: {
    paddingRight: 24,
    paddingBottom: 24,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
}));
